/**
 * lockdownCompatibility.js
 *
 * Defines which device models do not support the lockdown feature.
 * To exclude additional models in the future, add their model string to
 * LOCKDOWN_UNSUPPORTED_MODELS below.
 */

const LOCKDOWN_UNSUPPORTED_MODELS = new Set([
  "xe360mt-wf",
]);

/**
 * Returns true if the given device model supports lockdown.
 * Devices with an unknown or missing model value are assumed to support lockdown.
 *
 * @param {string|null|undefined} model - The device model string
 * @returns {boolean}
 */
export function supportsLockdown(model) {
  if (!model) return true;
  return !LOCKDOWN_UNSUPPORTED_MODELS.has(model.toLowerCase());
}
